require('../modules/web.dom.iterable');
require('../modules/es6.string.iterator');
module.exports = require('../modules/core.is-iterable');



//////////////////
// WEBPACK FOOTER
// ../~/babel-runtime/~/core-js/library/fn/is-iterable.js
// module id = 2468
// module chunks = 121